import { APICallV2Get, APICallV2Post } from 'reactApp/api/APICall';
import type { FeedApiResponse, SharedFolderApiResponse } from 'reactApp/modules/feed/feed.types';
import type { Sort } from 'reactApp/types/Tree';

export interface IDocumentsApiArgs {
    limit?: number;
    cursor?: string;
    exts?: string;
    ignore_mounts?: boolean;
    sort?: Sort;
}

export class DocumentsApiCall extends APICallV2Post<{ body: FeedApiResponse }> {
    _method = 'feed';
}

export class SharedIncomingApiCall extends APICallV2Get<{ body: SharedFolderApiResponse }> {
    _method = 'folder/shared/incoming';
}
